import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    resize: vertical;
  }

  .question-type {
    display: flex;
    align-items: center;
    gap: 8px;
    
    span {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .options-container {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h4 {
      margin: 0;
    }

    .option-row {
      display: flex;
      gap: 8px;
      align-items: center;

      input {
        flex: 1;
        padding: 8px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
      }
    }
  }

  #app-button {
    align-self: flex-end;
  }
`;
